import apis from '../apis/apis'

const tuHuyProcessor = {}
const controllerName = 'TuHuy'

tuHuyProcessor.countBanSaoByKhoaThi = async (id) => {
  const rs = await apis[controllerName].CountBanSaoByKhoaThi({ param: `/${id}` })
  return rs.isSuccess ? rs.data : 0
}
tuHuyProcessor.countDaDuyetByKhoaThi = async (id) => {
  const rs = await apis[controllerName].CountDaDuyetByKhoaThi({ param: `/${id}` })
  return rs.isSuccess ? rs.data : 0
}
tuHuyProcessor.countChuaDuyetByKhoaThi = async (id) => {
  const rs = await apis[controllerName].CountChuaDuyetByKhoaThi({ param: `/${id}` })
  return rs.isSuccess ? rs.data : 0
}
tuHuyProcessor.countImportByKhoaThi = async (id) => {
  const rs = await apis[controllerName].CountImportByKhoaThi({ param: `/${id}` })
  return rs.isSuccess ? rs.data : 0
}
tuHuyProcessor.xoaDaDuyet = async (id) => {
  const rs = await apis[controllerName].TuHuyByDaDuyet({
    method: 'post',
    responseType: 'text',
    param: `/${id}`,
  })
  return rs
}
tuHuyProcessor.xoaChuaDuyet = async (id) => {
  const rs = await apis[controllerName].TuHuyByChoDuyet({
    method: 'post',
    responseType: 'text',
    param: `/${id}`,
  })
  return rs
}
tuHuyProcessor.xoaBanSao = async (id) => {
  const rs = await apis[controllerName].TuHuyByBanSao({
    method: 'post',
    responseType: 'text',
    param: `/${id}`,
  })
  return rs
}
tuHuyProcessor.xoaImport = async (id) => {
  const rs = await apis[controllerName].TuHuyByImport({
    method: 'post',
    responseType: 'text',
    param: `/${id}`,
  })
  return rs
}

export default tuHuyProcessor
